// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"4":"70a76a3c","115":"6ec8b2a9","594":"1aacc152","652":"03ea35c6","821":"b1e55cbc","936":"6e327157"}[chunkId] + ".js";
};